// Make sure to add the key to the ROUTER_STATE_KEYS object below to avoid conflicts. Provide a description of the key's purpose.
// Usage: hooks/router_state.js

export const ROUTER_STATE_KEYS = {
  openAIAssistChat: 'openAIAssistChat', // Used to open the AI Assist Chat Bot on any page
  openAIProfitReport: 'openAIProfitReport' // Used to open the AI Report Slideout on Profit Overview
}
